/* eslint-disable no-undef */
import React, { useEffect, useRef, useState } from 'react';
import { Parser } from 'html-to-react';
import { popupWin } from 'components/PopUps';
import Otp from 'components/Otp/Otp'
import utils from "utils";
import { saveModel, generateB2SeeToken } from '../../utils/Functions';

import { LabelError, StepBody, ButtonLink, Spinner, ButtonSmall, Center, PhoneField, IdNumberField, LabelSubTitle, Paragraph, Row, MainCond, useInput, CheckValidInputs, RowCenter, LabelCenter } from 'meitav-uikit';
import { isMobile } from 'react-device-detect';

const getCID = function () {
  let cid = null;
  const cookie = document.cookie;
  if (cookie !== undefined && cookie.length > 0) {
    const cookies = cookie.split("_ga")[1];
    if (cookies !== undefined && cookies.length > 0)
      cid = cookies.split("=")[1].split(";")[0];
    if (cid) {
      var cidString = cid.split(".");
      if (cidString.length > 3) {
        cid = cidString[2] + "." + cidString[3];
      }
    }
  }
  return cid;
};

const getGCLID = function () {
  let gclid = null;
  const cookie = document.cookie;
  if (cookie !== undefined && cookie.length > 0) {
    const cookies = cookie.split("_gcl_aw")[1];
    if (cookies !== undefined && cookies.length > 0)
      gclid = cookies.split("=")[1].split(";")[0];
    if (gclid) {
      var gclidstring = gclid.split(".");
      if (gclidstring.length > 2) {
        gclid = gclidstring[2];
      }
    }
  }
  return gclid;
};

function getDCLID() {
  let dclid = null;
  const cookie = document.cookie;
  if (cookie !== undefined && cookie.length > 0) {
    const cookies = cookie.split("_gcl_dc")[1];
    if (cookies !== undefined && cookies.length > 0)
      dclid = cookies.split("=")[1].split(";")[0];
    if (dclid) {
      var dclidString = dclid.split(".");
      if (dclidString.length > 2) {
        dclid = dclidString[2];
      }
    }
  }
  return dclid;
}

function getFBCLID() {
  let dclid = null;
  const cookie = document.cookie;
  if (cookie !== undefined && cookie.length > 0) {
    const cookies = cookie.split("_fbc")[1];
    if (cookies !== undefined && cookies.length > 0)
      dclid = cookies.split("=")[1].split(";")[0];
    if (dclid) {
      var dclidString = dclid.split(".");
      if (dclidString.length > 2) {
        dclid = dclidString[2];
      }
    }
  }
  return dclid;
}
const PopUpDeeplink = props => {
  const { UmbracoUtills, rest } = utils;
  const p = new Parser();
  const phone = useInput(UmbracoUtills.getValueByKeyLp(props.resource, "phone"), '', [MainCond.empty, MainCond.phone, MainCond.onlyDigits]);
  const iDNumber = useInput(UmbracoUtills.getValueByKeyLp(props.resource, "taz"), '', [MainCond.empty, MainCond.identity]);
  const [otpCheck, setOtpCheck] = useState(false);
  const otpValue = useInput("", "");
  const [blocked, setBlocked] = useState(false);
  const [message, setMessage] = useState('');
  const [popupObj, setPopupObj] = useState("");
  const [recapchaKey, setRecapchaKey] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [notMiddleProcess, setNotMiddleProcess] = useState(false);

  useEffect(() => {
    getRecapchaKey();
    let obj = {};
    obj.type = "message";
    obj.handleClose = handleCloseInvalidOtp;
    obj.specialText = p.parse(UmbracoUtills.getValueByKey(props.resourceOtp, 'invalidOtpTriedLimit'));
    //obj.class
    setPopupObj(obj);
  }, []);
  const getRecapchaKey = async () => {
    await rest.get("/api/manager/GetRecapchaKey").then((res) => {
      setRecapchaKey(res.data);
      // recaptcha
      const recapchaScript = document.createElement("script");
      recapchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${res.data}`;

      recapchaScript.async = true;
      recapchaScript.defer = true;
      document.head.appendChild(recapchaScript);
    });
  };
  const handleCloseInvalidOtp = () => {
    window.location.href = "/CustomerInvestPolicy";
  };
  const handleClose = () => {

    props.handleClose();
  }

  const handleCick = e => {
    window.dataLayer.push({ 'event': 'digital-manager', 'eventInfo': { 'Category': 'trade - כללי', 'Action': 'חזרה לתהליך', 'Label': 'שליחת פרטים לקבלת SMS לחזרה לתהליך' } });

    if (!CheckValidInputs([phone, iDNumber])) {
      return;
    }



    const formData = {};
    let VisitorKey = "";
    try {
      VisitorKey = window.ewt.getVisitorKey();
    } catch (err) {
      VisitorKey = "";
    }

    formData.phone = phone.value;
    formData.tz = iDNumber.value;
    formData.cid = getCID();
    formData.gclid = getGCLID();
    formData.dclid = getDCLID();
    formData.fbclid = getFBCLID();
    formData.visitorKey = VisitorKey;

    setShowSpinner(true);

    if (grecaptcha === undefined) {
      alert('Recaptcha non definito');
      reject();
    }
    grecaptcha.enterprise
      .execute(recapchaKey, {
        action: 'LoginDeepLink',
      })
      .then(function (token) {
        rest
          .post('/api/manager/LoginDeepLink', {
            data: formData,
            headers: {
              gCaptcha: token,
              action: 'LoginDeepLink',
            },
          })
          .then(res => {

            setShowSpinner(false);
            if (res?.data?.errorMessage == "backToProcessTriesLimit") {
              setMessageError(p.parse(UmbracoUtills.getValueByKeyLp(props.resource, "backToProcessTriesLimit")));

            } else if (res?.data?.errorMessage == "notMiddleProcess") {
              // let obj = {};
              //obj.type = "notMiddleProcess";
              // obj.resourceUpContact = props.resourceUpContact
              // obj.resource = props.resourceNotMiddleProcess;
              // popupWin(obj);
              setNotMiddleProcess(true);
            }

            if (res.data.errorMessage === 'none') {
              localStorage.setItem('otpGuid', res?.data?.otpGuid);
              setOtpCheck(true);
            }

          });


      });
    generateB2SeeToken(iDNumber.value, VisitorKey);

  };

  function handleSubmitOtp() {

    const otpGuid =
      localStorage.getItem('otpGuid') &&
        localStorage.getItem('otpGuid') != 'undefined'
        ? localStorage.getItem('otpGuid')
        : null;
    if (otpValue.value == null || otpValue.value == "")
      return;

    return new Promise(function (resolve, reject) {
      if (grecaptcha === undefined) {
        alert('Recaptcha non definito');
        reject();
      }
      grecaptcha.enterprise
        .execute(recapchaKey, {
          action: 'ConfirmPassword',
        })
        .then(function (token) {
          rest
            .get(`/api/manager/ConfirmPassword?otpCode=${otpValue.value}&otpGuid=${otpGuid}&isDeeplink=true`, {
              headers: {
                gCaptcha: token,
                action: 'ConfirmPassword',
              },
            })
            .then(result => {
              if (result?.data != 'invalidOtpTriedLimit' && result?.data != "invalidOtp") {
                window.localStorage.setItem('processGuid', result?.data);
                window.localStorage.setItem('deepLink', "true");

                window.dataLayer.push({ 'event': 'digital-manager', 'eventInfo': { 'Category': 'trade - כללי', 'Action': 'חזרה לתהליך', 'Label': 'הזנה מוצלחת של קוד אימות לטובת חזרה לתהליך' } });

                window.dataLayer.push({
                  event: "PM - private details",
                  eventInfo: {
                    action_screen: "/JoinPersonalDetails",
                    process_level: "קוד אימות",
                    action_name: "שליחת קוד אימות",
                  },
                });
                getProcess(result?.data);
              } else {

                otpValue.setValue("");
                setMessage(result?.data);
                if (result?.data === 'invalidOtpTriedLimit') {
                  setBlocked(true);
                  popupWin(popupObj);
                }
              }
            });
        });
    });
  }

  const getProcess = async (processGuid) => {

    rest.get(`/api/manager/GetManagerProcess`)
      .then(res => {
        if (res.data != null) {
          window.localStorage.setItem("model", res.data)
          saveModel(res.data, 21);
          window.popupClose();
          window.location.href = "/JoinPersonalDetails";
        }
      });


  };
  const handleCickContactUs = () => {
    let obj = {};
    obj.type = "contactUs";
    obj.resource = props.resourceUpContact;
    obj.className = "contactUs";
  obj.flagSrc="deeplink";

    popupWin(obj);
  }
  const handleCickTryAgain = () => {

    setOtpCheck(false);
    setNotMiddleProcess(false);
  }
  return (
    <Row className='PopUpDeeplink'>
      {showSpinner && <Spinner />}


      {(!otpCheck && !notMiddleProcess && !showSpinner) && <>

        <LabelSubTitle align="center">{p.parse(UmbracoUtills.getValueByKeyLp(props.resource, "title"))}</LabelSubTitle>
        <Paragraph>{p.parse(UmbracoUtills.getValueByKeyLp(props.resource, "subTitle"))}</Paragraph>
        <RowCenter addClass={`${!isMobile ? 'small' : ""} `}>
            <PhoneField {...phone} id="phone" />
            <IdNumberField id="iDNumber" {...iDNumber} />
            <ButtonSmall text={UmbracoUtills.getValueByKeyLp(props.resource, "submit")} onClick={handleCick} />
          {messageError != "" ? (
              <LabelError text={messageError}>
              </LabelError>
          ) : (
            ""
          )}
        </RowCenter></>
      }
      {(otpCheck && !notMiddleProcess && !showSpinner) &&
        <Row>
          <Otp
            textIcon={UmbracoUtills.getValueByKey(props.resourceOtp, "icon")}
            textTitle={UmbracoUtills.getValueByKey(props.resourceOtp, "title")}
            subTitle={UmbracoUtills.getValueByKey(props.resourceOtp, "subTitle")}
            textDescription={UmbracoUtills.getValueByKey(props.resourceOtp, "sendAgain")}
            otpValue={otpValue} recapchaKey={recapchaKey}
            resourceError={props.resourceOtp} handleCick={handleSubmitOtp}
            blocked={blocked} handleSubmitOtp={handleSubmitOtp}
            message={message} setMessage={setMessage}
          ></Otp>

          <ButtonSmall text={UmbracoUtills.getValueByKey(props.resourceOtp, "submit")} onClick={handleSubmitOtp} />
          {messageError != "" ? (
            <Row>
              <LabelError text={messageError}>
              </LabelError>
            </Row>
          ) : (
            ""
          )}
        </Row>
      }
      {
        (notMiddleProcess && !showSpinner) &&
        <RowCenter addClass={`${!isMobile ? 'small' : ""} `}>
          <LabelSubTitle align="center">{UmbracoUtills.getValueByKey(props.resourceNotMiddleProcess, "title")}</LabelSubTitle>
          <Paragraph align="center">{p.parse(UmbracoUtills.getValueByKey(props.resourceNotMiddleProcess, "subTitle"))}</Paragraph>
          <ButtonSmall text={UmbracoUtills.getValueByKey(props.resourceNotMiddleProcess, "contactUsBtnText")} onClick={handleCickContactUs} />
          <ButtonLink text={UmbracoUtills.getValueByKey(props.resourceNotMiddleProcess, "tryAgainBtnText")} onClick={handleCickTryAgain}></ButtonLink>
        </RowCenter>
      }
    </Row>
  );
};

export default PopUpDeeplink;
